export interface Bonus {
  number: string
  title: string
  value: string
  description: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 150-Drill Quick-Reference Library',
    value: '$27',
    description: 'Every drill you’ll ever need, categorised and ready.',
    image:
      'https://cdn.magicpatterns.com/uploads/ezKwfxyetnZpQyKgDG6Uq5/ChatGPT_Image_12_sept_2026,_03_58_49.webp',
    alt: 'Bonus 1 cover: The 150-Drill Quick-Reference Library',
  },
  {
    number: '02',
    title: 'The “Magic Cues” Cheat Sheet',
    value: '$27',
    description:
      '100 common errors and the exact words to fix them instantly.',
    image:
      'https://cdn.magicpatterns.com/uploads/8xpFukjuxTkuzPbhWg6MD2/ChatGPT_Image_12_sept_2026,_04_01_16.webp',
    alt: 'Bonus 2 cover: The “Magic Cues” Cheat Sheet',
  },
  {
    number: '03',
    title: 'The Games & Challenges Catalog',
    value: '$19',
    description:
      '75 competitive activities to make your lessons the most fun in town.',
    image:
      'https://cdn.magicpatterns.com/uploads/nYZYMF2Doam8UPgvX3xitS/ChatGPT_Image_12_sept_2026,_04_02_18.webp',
    alt: 'Bonus 3 cover: The Games & Challenges Catalog',
  },
  {
    number: '04',
    title: 'Emergency Lesson Plans — 5-Minute Prep',
    value: '$19',
    description: 'The 5-minute lifesaver for last-minute sessions.',
    image:
      'https://cdn.magicpatterns.com/uploads/9fTrtLRChHheu3pWyvZn83/ChatGPT_Image_12_sept_2026,_04_03_36.webp',
    alt: 'Bonus 4 cover: Emergency Lesson Plans, 5-Minute Prep',
  },
  {
    number: '05',
    title: 'Team Games & Tournament Formats',
    value: '$19',
    description:
      'Ready-to-play team games, skill challenges and fun tournaments for every level.',
    image:
      'https://cdn.magicpatterns.com/uploads/ukM7KbTiQwnprSzJtKUsby/ChatGPT_Image_12_sept_2026,_04_04_39.webp',
    alt: 'Bonus 5 cover: The Pickleball Games & Challenges Catalog',
  },
  {
    number: '06',
    title: 'The Court-Side Injury Prevention Guide',
    value: 'Included',
    description:
      'Warm-ups, cool-downs and recovery routines that keep players on court.',
    image:
      'https://cdn.magicpatterns.com/uploads/qMytpVtikS4DCNGzMpbPLg/ChatGPT_Image_12_sept_2026,_04_05_41.webp',
    alt: 'Bonus 6 cover: The Court-Side Injury Prevention Guide',
  },
  {
    number: '07',
    title: 'The Professional Coach’s Welcome Packet',
    value: 'Included',
    description:
      'Templates and tools that impress your players from day one.',
    image:
      'https://cdn.magicpatterns.com/uploads/6kcDwgBY5fwAXCuKGwcY2x/ChatGPT_Image_12_sept_2026,_04_06_37.webp',
    alt: 'Bonus 7 cover: The Professional Coach’s Welcome Packet',
  },
]

export const bonusTotalValue = '$111'
